
<template>
  <div class="reports">
    <h1>Leads Center<span class="h1-underline"></span></h1>
    <FiltersLeads :estados="estados" @change-estado="updateEstado"/>
    <v-card>
      <v-card-title class="">
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="user_level > 1 ? headersAdmin : headersAgent"
        :items="filteredLeads"
        :search="search"
      >
      <template v-slot:item.detalhes="{ item }">
        <LeadDetail :lead="item"/>
      </template>
      <template v-slot:item.editar="{ item }">
        <LeadInsertData :lead="item" @update-made="collect_leads"/>
      </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import FiltersLeads from '@/components/Filters_Leads';
import LeadDetail from '@/components/Lead_Detail';
import LeadInsertData from '@/components/Lead_Insert_Data';
export default {
  components: {
    FiltersLeads,
    LeadDetail,
    LeadInsertData
  },
  name: 'Leads',
    data () {
      return {
        search: '',
        username: '',
        headersAgent: [
          {
            text: 'ID',
            align: 'left',
            value: 'lead_process_id',
          },
          // { text: 'Data', align: 'center', value: 'dt_created', sortable:true },
          { text: 'Nome', align: 'center', value: 'nome', sortable:true },
          { text: 'Email', align: 'center', value: 'email', sortable:true },
          { text: 'Telefone', align: 'center', value: 'telefone', sortable:true },
          { text: 'Montante', align: 'center', value: 'aux_1', sortable:true },
          // { text: 'Prazo', align: 'center', value: 'aux_2', sortable:true },
          { text: 'Último Contacto', align: 'center', value: 'last_interation', sortable:true },
          { text: 'Agendamento', align: 'center', value: 'callback_date', sortable:true },
          { text: 'Estado', align: 'center', value: 'current_step', sortable:true },
          { text: 'Detalhes', align: 'center', value: 'detalhes', sortable:true },
          { text: 'Editar', align: 'center', value: 'editar', sortable:false },
        ],
        
        headersAdmin: [
          {
            text: 'ID',
            align: 'left',
            value: 'lead_process_id',
          },
          { text: 'Mediador', align: 'center', value: 'username', sortable:true },
          { text: 'Nome', align: 'center', value: 'nome', sortable:true },
          { text: 'Email', align: 'center', value: 'email', sortable:true },
          { text: 'Telefone', align: 'center', value: 'telefone', sortable:true },
          { text: 'Montante', align: 'center', value: 'aux_1', sortable:true },
          // { text: 'Prazo', align: 'center', value: 'aux_2', sortable:true },
          { text: 'Último Contacto', align: 'center', value: 'last_interation', sortable:true },
          { text: 'Agendamento', align: 'center', value: 'callback_date', sortable:true },
          { text: 'Estado', align: 'center', value: 'current_step', sortable:true },
          { text: 'Detalhes', align: 'center', value: 'detalhes', sortable:true },
          { text: 'Editar', align: 'center', value: 'editar', sortable:false },
        ],
        items: [],
        loader: null,
        loading: false,
        loading2: false,
        loading3: false,
        loading4: false,
        loading5: false,

        user_level: null,
        estados: [],
        estado: "All"
      }
    },
    computed: {
      filteredLeads() {
        if(this.estado == "All") {
          return this.items
        }
        else {
          let map = this.items.filter(e => {
            return e.current_step == this.estado
          })
          
          return map
        }
      }
    },
    methods: {
      updateEstado: async function(val) {
        this.estado = val
      },
      collect_leads: async function () {
        let url
        if(this.user_level > 1) {
          url = "https://app.reorganiza.pt/public/api/all-leads-in-process-new"
        }
        else {
          url = "https://app.reorganiza.pt/public/api/my-leads-in-process-new/"+this.username
        }

        const dados = await this.call_api_get(url)
        const d = Object.keys(dados).map(i => dados[i])

        this.items = d

        this.estados = [...new Set(d.map(item => item.current_step))]
        this.estados.push("All")
      },
      collect_lead_data: async function (lead_process_id) {
        let url = "https://app.reorganiza.pt/public/api/lead-p-details/"+lead_process_id

        const dados = await this.call_api_get(url)

        return dados
      },
      call_api_get: async function (url) {
          try {
              var response = await fetch(url, {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json'
                  }
              })
              var result = await response.json()
              return result
          }
          catch (error) {
              console.error('Error:', error)
              return 'Error: ' + error
          }
      }
    },
    mounted: function () {
      let isLogged = window.sessionStorage.getItem('user_id')
      const result = isLogged == null ? false : true

      if(!result) {
          this.$router.push('login')
      }
      else {
          console.log("session is valid")
          this.username = window.sessionStorage.getItem('username')
          this.user_level = window.sessionStorage.getItem('user_level')
      }

      this.collect_leads()
    },
    updated() {
      // this.colect_leads()
    }
  }
</script>

<style scoped>
    h1{
      margin-left: 296px;
      color: black;
      font-size: 20px;
      text-transform: uppercase;
      margin-top: 50px;
      position: relative;
      display: block;
    }
    .h1-underline{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 60px;
      height: 3px;
      background-color: black;
      margin-bottom: -6px;
    }
    .v-card{
        margin: 10px 40px 50px 296px;
        padding: 40px;
        padding-top:10px;

    
    }
    .v-card__title{
        margin-bottom: 30px;
    }
    

</style>>
   